import { useFormCampaignContext } from '../hooks/useFormCampaignContext'

const Stepper = () => {
  const { ctx } = useFormCampaignContext()

  return (
    <ol className='flex items-center justify-center w-full p-3 space-x-2 text-sm font-medium text-center text-gray-500 bg-white rounded-lg shadow-xs dark:text-gray-400 sm:text-base dark:bg-gray-800 dark:border-gray-700 sm:p-4 sm:space-x-4 rtl:space-x-reverse'>
      <li className={ctx.step === 0 ? 'flex items-center text-blue-600 dark:text-blue-500' : 'flex items-center'}>
        <span className={ctx.step === 0 ? 'flex items-center justify-center w-5 h-5 me-2 text-xs font-medium text-blue-600 bg-blue-100 rounded-full shrink-0 dark:bg-blue-900 dark:text-blue-200' : 'flex items-center justify-center w-5 h-5 me-2 text-xs border border-gray-500 rounded-full shrink-0 dark:border-gray-400'}>
          1
        </span>
        Datos <span className='hidden sm:inline-flex sm:ms-2'>Campaña</span>
        <svg className='w-3 h-3 ms-2 sm:ms-4 rtl:rotate-180' aria-hidden='true' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 12 10'>
          <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='m7 9 4-4-4-4M1 9l4-4-4-4' />
        </svg>
      </li>
      <li className={ctx.step === 1 ? 'flex items-center text-blue-600 dark:text-blue-500' : 'flex items-center'}>
        <span className={ctx.step === 1 ? 'flex items-center justify-center w-5 h-5 me-2 text-xs font-medium text-blue-600 bg-blue-100 rounded-full shrink-0 dark:bg-blue-900 dark:text-blue-200' : 'flex items-center justify-center w-5 h-5 me-2 text-xs border border-gray-500 rounded-full shrink-0 dark:border-gray-400'}>
          2
        </span>
        Configuración <span className='hidden sm:inline-flex sm:ms-2'>Campaña</span>
        <svg className='w-3 h-3 ms-2 sm:ms-4 rtl:rotate-180' aria-hidden='true' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 12 10'>
          <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='m7 9 4-4-4-4M1 9l4-4-4-4' />
        </svg>
      </li>
    </ol>
  )
}

export default Stepper
